import { render, staticRenderFns } from "./CCaseZh.vue?vue&type=template&id=7c497e40"
import script from "./CCaseZh.vue?vue&type=script&lang=js"
export * from "./CCaseZh.vue?vue&type=script&lang=js"
import style0 from "./CCaseZh.vue?vue&type=style&index=0&id=7c497e40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports